import { render, staticRenderFns } from "./Book.vue?vue&type=template&id=5a967f6c&scoped=true"
import script from "./Book.vue?vue&type=script&lang=js"
export * from "./Book.vue?vue&type=script&lang=js"
import style0 from "../styles/Book.css?vue&type=style&index=0&id=5a967f6c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a967f6c",
  null
  
)

export default component.exports